import * as React from 'react';
import { createContext, useContext } from 'react';

import { TColumnsVisibilityContextType } from '@/contexts/column-visibility/types.ts';

export const ColumnsVisibilityContext =
    createContext<TColumnsVisibilityContextType<unknown> | null>(null);

export function useColumnsVisibility<T>(): TColumnsVisibilityContextType<T> {
    const context = useContext(
        ColumnsVisibilityContext as React.Context<TColumnsVisibilityContextType<T> | null>
    );
    if (!context) throw new Error('Provider is missing');

    return context;
}
